import { JobHistoryLevel } from '@/common/graphql';

const TEAM_TARGET_ELIGIBLE_LEVELS = [
  JobHistoryLevel.L3,
  JobHistoryLevel.L4,
  JobHistoryLevel.L5,
  JobHistoryLevel.L6,
  JobHistoryLevel.L7,
];

const DEPARTMENT_TARGET_ELIGIBLE_LEVELS = [
  JobHistoryLevel.L3,
  JobHistoryLevel.L4,
  JobHistoryLevel.L5,
  JobHistoryLevel.L6,
  JobHistoryLevel.L7,
];

export const isTeamTargetEligibleByDefault = (level?: JobHistoryLevel) => {
  if (!level) {
    return false;
  }

  return TEAM_TARGET_ELIGIBLE_LEVELS.includes(level);
};

export const isDepartmentTargetEligibleByDefault = (level?: JobHistoryLevel | null) => {
  if (!level) {
    return false;
  }

  return DEPARTMENT_TARGET_ELIGIBLE_LEVELS.includes(level);
};
